import { gql, useQuery } from "@apollo/client";
import { get } from "lodash";

import deviceFingerprint from "src/shared/utilities/deviceFingerprint";

import useFeatureState from "./useFeatureState";

const MESSAGE_FLAGS_QUERY = gql`
  query message_flags($input: MessageFlagsInput!) {
    experts_program {
      message_flags(input: $input) {
        agent_flag
        rent_flag
      }
    }
  }
`;

const useMessageFlagsQuery = () => {
  const { expertsApiUuid } = useFeatureState();

  const { refetch } = useQuery(MESSAGE_FLAGS_QUERY, {
    fetchPolicy: "standby"
  });

  return async formValues => {
    const { body, name, phone, subject } = formValues;
    let result;

    try {
      const response = await refetch({
        input: {
          body,
          experts_api_uuid: expertsApiUuid,
          fingerprint_or_device_guid: deviceFingerprint(),
          sender_name: name,
          sender_phone: phone,
          subject
        }
      });

      const messageFlags = get(
        response,
        "data.experts_program.message_flags",
        {}
      );

      const showMessageScreening =
        messageFlags.agent_flag || messageFlags.rent_flag || false;

      let flag;
      if (messageFlags.agent_flag) {
        flag = "agent";
      } else if (messageFlags.rent_flag) {
        flag = "renter";
      }

      result = { flag, showMessageScreening };
    } catch (error) {
      result = { error };
    }

    return result;
  };
};

export default useMessageFlagsQuery;
